/* Centralized data-testid registry. */
export const TID = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginQuick: (role) => `login-quick-${role}`,
  logoutBtn: "logout-button",
  navItem: (k) => `nav-item-${k}`,
  metric: (k) => `metric-${k}`,
  walletBalance: (k) => `wallet-${k}-balance`,
  slot: (n) => `slot-${n}`,
  entryPlate: "entry-plate-input",
  entrySubmit: "entry-submit-button",
  exitSubmit: "exit-submit-button",
  alprUpload: "alpr-upload-input",
  alprRun: "alpr-run-button",
  visitorName: "visitor-name-input",
  visitorPlate: "visitor-plate-input",
  visitorCreate: "visitor-create-button",
  payQrCreate: "pay-qr-create-button",
  payConfirm: (id) => `pay-confirm-${id}`,
};
